import { addDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export class TimezoneDateRangeUtil {

  static todayToNextDays(
    timezone: string,
    days: number
  ): { minDate: Date; maxDate: Date } {

    // Current UTC time
    const nowUtc = new Date();

    // Convert to property timezone
    const zonedNow = toZonedTime(nowUtc, timezone);

    // Normalize start of day
    zonedNow.setHours(0, 0, 0, 0);

    // Calculate max date in SAME timezone
    const maxDate = addDays(zonedNow, days);
    maxDate.setHours(23, 59, 59, 999);

    return {
      minDate: zonedNow,
      maxDate
    };
  }
}
